export const BACKGROUND_COLOR = "#d8d9db";

export const WORK_HISTORY: {
  company: string;
  primaryColor: string;
  positions: {
    from: Date;
    to: Date;
    title: string;
    description: string;
    float?: string;
  }[];
}[] = [
  {
    company: "HubSpot",
    primaryColor: "#ff5c34",
    positions: [
      {
        from: new Date(2022, 10, 1),
        to: new Date(Date.now()),
        title: "Engineering Lead",
        description: `Oversaw multiple teams in a hands-on leadership capacity, balancing technical execution with people and project management responsibilities. Acted as a technical lead to several individual contributors, driving engineering excellence and delivery across initiatives.
\nKey Achievements:
\n- Championed the adoption of Shared Workers and Web Workers, improving performance and enabling a cohesive experience across web instances.
\n- Communcated directly with OpenAI to integrate the Agents SDK, delivering an in-app Q&A preview that expanded voice interaction capabilities.
\n- Led planning and execution for high-impact, cross-functional initiatives within a broader product group, aligning teams around shared goals and managing complex dependencies.
\n- Provided technical mentorship and leadership development, conducting PR reviews, coaching engineers, and growing new tech leads to expand organizational capacity.`,
      },
      {
        from: new Date(2020, 2, 1),
        to: new Date(2022, 10, 1),
        title: "Technical Lead",
        description: `Lead a team of front-end engineers while continuing to contribute directly to product development and delivery.
\nKey Achievements:
\n- Collaborated with third-party calling providers to support integration with HubSpot’s open-source SDK, providing technical guidance and partnership throughout the implementation process.
\n- Orchestrated and contributed to a large-scale front-end rewrite and redesign, partnering closely with the back-end team to deliver a significantly faster and more seamless user experience.`,
      },
      {
        from: new Date(2018, 8, 1),
        to: new Date(2020, 2, 1),
        title: "Sr Software Engineer",
        description:
          "IC on the conversations/communicator team working on HubSpots main facebook messenger integration, email, and calling features.",
      },
    ],
  },
  {
    company: "CarGurus",
    primaryColor: "#01a0dd",
    positions: [
      {
        from: new Date(2016, 5, 1),
        to: new Date(2018, 7, 1),
        title: "Sr Software Engineer",
        description: `As an individual contributor, I focused on delivering high-impact front-end improvements, introducing new technologies, and driving higher engineering standards across the product.
\nKey Achievements:
\n- Integrated the Optimizely SDK and conducted A/B testing to evaluate performance and effectiveness against the existing in-house experimentation framework.
\n- Introduced React into the product codebase, laying the foundation for a more modern, modular, and maintainable front-end architecture.
\n- Established engineering standards and developed build tools supporting ES6 and CSS Modules, improving code quality and consistency across teams.
\n- Introduced unit testing practices to strengthen code reliability and reduce regressions.
\n- Co-created an in-house functional testing framework using Chromedriver and Node.js, implementing automated tests for critical user flows to enhance overall product stability.
          `,
      },
    ],
  },
  {
    company: "Constant Contact",
    primaryColor: "#ff9e1a",
    positions: [
      {
        from: new Date(2018, 0, 1),
        to: new Date(2018, 8, 1),
        title: "Sr Software Engineer",
        description: `In the Contacts Team, I contributed to product development by working with legacy and modern front-end technologies to enhance user experience and maintain product functionality.
\nKey Contributions:
\n- Developed and maintained features using CoffeeScript, Backbone.js, and Marionette within the contacts application.
\n- Supported ongoing improvements and modernization of front-end components across the product.`,
      },
      {
        from: new Date(2014, 2, 1),
        to: new Date(2018, 0, 1),
        title: "Software Engineer",
        description: `As an individual contributor on the Website Team, I focused on enhancing internal tools, streamlining development processes, and creating reusable front-end components to improve efficiency and maintainability.
\nKey Contributions:
\n- Continued development on an internal Angular application, delivering key features and improvements.
\n- Built a drag-and-drop interface using Bootstrap 3 for intuitive page creation.
\n- Developed a bash script to simplify LAMP stack setup with Vagrant for other developers.
\n- Integrated Salesforce campaigns into a PHP blog using the REST API and SOQL, implementing features such as filtering, pagination, and search.
\n- Designed and planned a Style Guide with core components, written in LESS, including an Angular-driven usage page capable of dynamically displaying theme options.
\n- Received an Internal Innovation Jam award for developing an Angular-based meeting room finder application.
`,
      },
    ],
  },
  {
    company: "Karmaloop",
    primaryColor: "#000000",
    positions: [
      {
        from: new Date(2013, 5, 1),
        to: new Date(2014, 2, 1),
        title: "Frontend developer",
        description:
          "Implemented Optimizely A/B testing and contributed to navigation reformatting and the development of a one-page cart for Karmaloop. Delivered A/B test variations that reached over 120,000 visitors. Designed W3C-compliant email templates using ExactTarget and tested with Litmus.",
      },
    ],
  },
  {
    company: "WHDH-TV Channel 7",
    primaryColor: "red",
    positions: [
      {
        from: new Date(2010, 0, 1),
        to: new Date(2013, 5, 1),
        title: "Animator / Graphic Designer",
        description:
          "Designed and produced animated news graphics, spots, commercials, and shorts for special projects and news packages in a fast-paced, competitive environment. Assisted with still news graphics and supported daily news programs as needed.",
      },
    ],
  },
  {
    company: "Freelance Web & Graphic Designer",
    primaryColor: "#59588b",
    positions: [
      {
        from: new Date(2009, 0, 1),
        to: new Date(2010, 0, 1),
        title: "Self employeed",
        description:
          "Worked as a freelance web and graphic designer for various businesses in the Boston area. Designed and hand-coded websites, provided ongoing support and updates, and implemented MySQL-based image galleries, stores, and private storefronts. Created company logos, jerseys, print materials, and other branding assets.",
      },
    ],
  },
  {
    company: "Comcast CN8",
    primaryColor: "red",
    positions: [
      {
        from: new Date(2006, 5, 1),
        to: new Date(2009, 0, 1),
        title: "Graphic Designer",
        description:
          "Produced daily show graphics and animations for Backstage with Barry Nolan and Sports Pulse, delivering high-quality visual content to enhance each program.",
      },
    ],
  },
];
